import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Webcam from 'react-webcam';
import axios from 'axios';
import './passport.css';
import KycShell, { BrowserOnlyWarning } from '../components/KycShell';

const Passport = () => {
    const webcamRef = useRef(null);
    const brandname = localStorage.getItem('brandname');
    const [idimageSrc, setImageSrc] = useState(null);
    const [errorMessage , seterrorMessage ] = useState();
    const [uploading, setUploading] = useState('');
    const navigate = useNavigate();
    const setdocumenttitle = localStorage.getItem('setdocumenttitle');
    const address_proof = localStorage.getItem('address_proof');
    const front_back = localStorage.getItem('front_back');
    const [isMobile, setIsMobile] = useState(false);
    const [visible, setVisible] = useState(false);
    const [selvisible, setSelvisible] = useState(true);

    let textMsg = '';
    if (setdocumenttitle === 'Passport') {
        textMsg = 'We will not accept your passport if the image is not vertical.';
    }

    const checkIfMobile = () => {
        return window.innerWidth <= 768;
    };

    const updateMedia = () => {
        setIsMobile(checkIfMobile());
    };

    useEffect(() => {
        updateMedia();
        window.addEventListener('resize', updateMedia);
        return () => {
          window.removeEventListener('resize', updateMedia);
        };
    }, []);

    const capture = () => {
        const idimageSrc = webcamRef.current.getScreenshot({width: 720, height: 1280});
        setImageSrc(idimageSrc);

    };

    const handleUpload = async (event) => {
        if (idimageSrc) {
			 event.currentTarget.disabled = true;
			 setUploading('Uploading...');
            try {
                const datas = JSON.stringify({
                    "uuid": localStorage.getItem('uuid'),
                    "image": idimageSrc,
                    "type": setdocumenttitle,
                });

                const config = {
                    method: 'post',
                    url: 'https://kyc2.codegotech.com/save_image',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: datas
                };

                // Prima richiesta: Upload immagine
                const response = await axios.request(config);
                console.log('Upload response:', response);

                if (response.status === 200) {
                    if (response.data.status === 1) {
                        if (response.data.sizestatus === 1 || setdocumenttitle !== 'Passport') {
                            const front_backs = localStorage.getItem('front_back');
                            const kyctype = localStorage.getItem('kyctype');
                            const partial_page = localStorage.getItem('partial_page');
                            const address_proof = localStorage.getItem('address_proof');

                            if (front_backs === '1') {
                                localStorage.setItem('passportPhoto', response.data.image);
                                navigate('/idproofback');
                            } else {
                                if (kyctype === 'partial' && partial_page === 'ID') {
                                    const userData = JSON.stringify({
                                        "type": setdocumenttitle,
                                        "uuid": localStorage.getItem('uuid'),
                                        "kyctype": kyctype,
                                        "partial_page": partial_page,
                                        "userAgent": localStorage.getItem('userAgent'),
                                        "ip_address": localStorage.getItem('Ip-Adrees'),
                                        "passportPhoto": response.data.image
                                    });

                                    const userConfig = {
                                        method: 'post',
                                        url: 'https://kyc2.codegotech.com/send_userdata',
                                        headers: {
                                            'Content-Type': 'application/json'
                                        },
                                        data: userData
                                    };

                                    // Seconda richiesta: Inviare dati utente
                                    const userResponse = await axios.request(userConfig);
                                    console.log('Send user data response:', userResponse);

                                    if (userResponse.status === 200) {
                                        localStorage.removeItem('userAgent');
                                        localStorage.removeItem('Ip-Adrees');
                                        localStorage.removeItem('passportphoto');
                                        localStorage.removeItem('uuid');
                                        navigate('/process');
                                    }
                                } else {
                                    localStorage.setItem('passportPhoto', response.data.image);
                                    if (address_proof === '1') {
                                        navigate('/proof');
                                    } else {
                                        navigate('/Recognition');
                                    }
                                }
                            }
                        } else {
                            setVisible(false);
                            setSelvisible(true);
                            const html = 'Please re-upload passport image. Image should be vertical position';
                            document.getElementById('mrz-data').innerHTML = html;
                        }
                    } else {
                        setVisible(false);
                        setSelvisible(true);
                        const html = 'Please re-upload passport image.';
                        document.getElementById('mrz-data').innerHTML = html;
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
    };




    useEffect(() => {

    }, [isMobile]);

    return (
        <>
            {!isMobile && <BrowserOnlyWarning />}
            {isMobile && (
                <KycShell step={2} brandName={brandname}>
                    <div className="kyc-card">
                        <div className="kyc-card__eyebrow">Capture document</div>
                        <h1 className="kyc-card__title">
                            {setdocumenttitle} {front_back === '1' ? '— front side' : ''}
                        </h1>
                        <p className="kyc-card__subtitle">
                            Make sure all information is clearly visible, corners are
                            inside the frame and the photo is not blurred.
                        </p>

                        <div className="kyc-camera-wrap bg_camera proof">
                            {idimageSrc ? (
                                <img src={idimageSrc} alt="Captured" className="img-fluid" />
                            ) : (
                                <>
                                    <Webcam
                                        audio={false}
                                        ref={webcamRef}
                                        screenshotFormat="image/jpg"
                                        videoConstraints={{
                                            width: 1280, height: 720,
                                            facingMode: "environment"
                                        }}
                                        className="webcam proof"
                                        width={1280}
                                        height={720}
                                    />
                                    <div className="kyc-camera-overlay" />
                                    <div className="kyc-camera-hint">
                                        Align document within the frame
                                    </div>
                                    <button
                                        type="button"
                                        onClick={capture}
                                        className="kyc-capture-btn"
                                        aria-label="Capture"
                                    />
                                </>
                            )}
                        </div>

                        {idimageSrc && (
                            <>
                                {uploading && (
                                    <p style={{ color: 'var(--kyc-danger)', margin: 0, fontSize: 13, fontWeight: 500 }}>
                                        {uploading}
                                    </p>
                                )}
                                <div className="kyc-capture-actions">
                                    <button onClick={() => setImageSrc(null)} className="kyc-btn kyc-btn-secondary btn_retake">
                                        <i className="fa fa-repeat" aria-hidden="true"></i> Retake
                                    </button>
                                    <button onClick={handleUpload} disabled={!idimageSrc} className="kyc-btn kyc-btn-primary btn_retake upload">
                                        Submit <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </>
                        )}

                        <div className="kyc-example">
                            <p className="kyc-example__label">Example {setdocumenttitle}</p>
                            <img src={localStorage.getItem('id_image')} className="example_pic" alt="example" />
                        </div>

                        <div id='mrz-data' style={{ color: 'var(--kyc-danger)', fontSize: 13, fontWeight: 500 }}>
                            {errorMessage}
                        </div>
                    </div>
                </KycShell>
            )}
        </>
    );
};

export default Passport;
